export const optionTitle_textSizeSpacing = "vMW6Dc";
export default {optionTitle_textSizeSpacing};